import { z } from 'zod'

/**
 * `LGH-049`. Console's own vocabulary for a demo submission — kept distinct
 * from the contract schema in `contract-read.ts` for the same reason every
 * other console type here is: a translation step gives this side somewhere
 * to stand if the wire changes without the console needing to.
 */
export const demoSubmissionLabelDispositionSchema = z.enum(['confirmed', 'rejected'])
export type DemoSubmissionLabelDisposition = z.infer<typeof demoSubmissionLabelDispositionSchema>

export const demoSubmissionLabelSchema = z
  .object({
    lineIndex: z.number(),
    lineText: z.string(),
    disposition: demoSubmissionLabelDispositionSchema,
    shownIdentity: z.string(),
    shownEvidence: z.unknown(),
    shownScore: z.string().nullable(),
  })
  .strict()
export type DemoSubmissionLabel = z.infer<typeof demoSubmissionLabelSchema>

export const demoSubmissionSchema = z
  .object({
    id: z.string(),
    visitorId: z.string(),
    pastedText: z.string(),
    createdAt: z.string(),
    isRepeatVisitor: z.boolean(),
    labels: z.array(demoSubmissionLabelSchema),
  })
  .strict()
export type DemoSubmission = z.infer<typeof demoSubmissionSchema>

export const demoSubmissionListSchema = z.array(demoSubmissionSchema)
